import React from "react";
import { Link } from "react-router-dom";
import { Captions, Clapperboard, Music2, Scissors } from "lucide-react";
import { clipCost } from "../../hooks/useVideoStudio";

const PERKS = [[Clapperboard, "Realistic clips from a description or a photo"], [Scissors, "Trim and join clips"], [Captions, "Add captions"], [Music2, "Add background music"]];

export const VideoLocked = ({ pricing }) => (
  <div className="h-full overflow-y-auto thin-scroll p-6 sm:p-10 flex items-start sm:items-center justify-center" data-testid="video-locked">
    <div className="max-w-md w-full rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 shadow-sm">
      <span className="w-11 h-11 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center"><Clapperboard size={20} /></span>
      <h2 className="mt-4 text-lg font-semibold tracking-tight text-slate-900">Make AI videos for your app</h2>
      <p className="mt-1.5 text-sm text-slate-500">Video Studio is for customers who have bought credits. Buy any credit pack to unlock it.</p>
      <ul className="mt-5 space-y-2.5">
        {PERKS.map(([Icon, t]) => <li key={t} className="flex items-center gap-2.5 text-sm text-slate-700"><Icon size={14} className="text-emerald-600" /> {t}</li>)}
      </ul>
      {pricing && <p className="mt-5 text-xs text-slate-500" data-testid="video-locked-price">From {clipCost(pricing, "fast", 5)} credits for a 5-second clip.</p>}
      <Link to="/billing" data-testid="video-locked-buy-btn"
        className="mt-5 inline-flex h-10 px-5 rounded-full bg-emerald-600 text-white text-sm font-medium items-center hover:bg-emerald-700 transition-colors">Buy credits</Link>
    </div>
  </div>
);

export default VideoLocked;
